import * as actions from './modalActions';

const modalReducers = {
  [actions.MODAL_OPEN]: (
    state,
    { payload: { scrollTop, activeModal, data } }
  ) => {
    state.data = data;
    state.activeModal = activeModal;
    if (typeof scrollTop === 'number') state.scrollTop = scrollTop;
    return state;
  },
  [actions.MODAL_CLOSE]: (state, { payload: { activeModal } }) => {
    if (state.activeModal === activeModal) {
      delete state.activeModal;
      delete state.scrollTop;
    }
    return state;
  },
  [actions.MODAL_CLEAR_DATA]: state => {
    delete state.data;
    return state;
  },
};

export default {
  name: 'modal',
  reducers: modalReducers,
};
